import GlobalBusy from 'components/app/GlobalBusy'
import React, { useEffect } from 'react'
import { Route, Redirect } from 'react-router'
import authActions from 'pages/Auth/actions'
import { useSelector } from 'react-redux'
import { AppRouteURI } from './RoleBasedAccess'

const GuestRoute = ({ component: Component, ...rest }) => {
    const { loggedIn, fetching } = useSelector((state) => state.auth)
    const { checkAuthentication } = authActions()

    useEffect(() => {
        checkAuthentication()
    }, [])

    return (
        <Route
            {...rest}
            render={(props) => {
                const afterFetched = loggedIn ? (
                    <Redirect to={AppRouteURI.HOME} />
                ) : (
                    <Component {...props} />
                )
                return fetching ? <GlobalBusy /> : afterFetched
            }}
        />
    )
}

export default GuestRoute
